// Implements: F-GEN-033, F-GEN-034
/**
 * The wire shapes of `/api/mockups/{id}/diagrams` (mockup v3 P6 contract C6.1 and C6.2).
 *
 * A version holds two independent diagrams: the journey (artifact kind `diagram`) and the screen
 * walkthrough (artifact kind `diagram_walkthrough`). Each is drawn once per version, and every
 * refusal is a `409` whose public `reason` is one of `DiagramRefusalReason`.
 */

import type { CostSummary } from "./api";

export type DiagramKind = "journey" | "walkthrough";

/** The artifact kind of `GET .../versions/{id}` that holds each diagram (C6.3). */
export const ARTIFACT_OF_KIND: Readonly<Record<DiagramKind, "diagram" | "diagram_walkthrough">> = {
  journey: "diagram",
  walkthrough: "diagram_walkthrough",
};

export type DiagramRefusalReason = "no_version" | "diagram_already_drawn" | "diagram_in_progress" | "journey_required";

/** The body of `POST .../diagrams` (C6.1). */
export interface RunDiagramRequest {
  readonly brief: string;
  readonly kind: DiagramKind;
  readonly generation_id?: string | null;
}

/** `POST .../diagrams` (200): the validated Mermaid of one drawn diagram. */
export interface DiagramRunView {
  readonly generation_id: string;
  readonly mockup_id: string;
  readonly version_id: string;
  readonly flow_version: string;
  readonly kind: DiagramKind;
  readonly source: string;
}

/** The body of `POST .../diagrams/estimate` (C6.2). */
export interface EstimateDiagramRequest {
  readonly brief: string;
  readonly kind: DiagramKind;
}

/** `POST /mockups/{id}/diagrams/estimate` (200): the price CEILING of the walkthrough step. */
export interface DiagramCostEstimate {
  readonly flow_version: string;
  readonly profile: { readonly tier: string };
  readonly prompt_tokens: number;
  readonly completion_tokens: number;
  readonly cost: CostSummary;
}
